import { render, staticRenderFns } from "./BaseSelect2.vue?vue&type=template&id=184e920e&scoped=true&"
import script from "./BaseSelect2.vue?vue&type=script&lang=js&"
export * from "./BaseSelect2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184e920e",
  null
  
)

export default component.exports